export const RowData = [
    {
      "RN": 1,
      "SKUCode": "300072-700300",
      "SKUDescription": "INSOFORM 15 - 300 KG",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "P102",
      "ParentWhDesc": "DKCI Dadra Plant",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 6000,
      "Stock": 0,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 6000,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 6000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Green",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "-",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 2,
      "SKUCode": "300076-500015",
      "SKUDescription": "INSOFORM 5 - 15 Kg",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "415",
      "ParentWhDesc": "DKCI Dadra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 6000,
      "Stock": 6000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 6000,
      "TOBlack_ReqQty": 6000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 6000,
      "RationedCasePacks": 6000,
      "TOBlack_AllocQty": 6000,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "6000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 3,
      "SKUCode": "300076-700300",
      "SKUDescription": "INSOFORM 5 - 300 KG",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "415",
      "ParentWhDesc": "DKCI Dadra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 12000,
      "Stock": 6000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 12000,
      "TOBlack_ReqQty": 12000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 6000,
      "RationedCasePacks": 6000,
      "TOBlack_AllocQty": 6000,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "6000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 4,
      "SKUCode": "300076-700300",
      "SKUDescription": "INSOFORM 5 - 300 KG",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "P102",
      "ParentWhDesc": "DKCI Dadra Plant",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 12000,
      "Stock": 6000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 6000,
      "TOBlack_ReqQty": 6000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "6000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 5,
      "SKUCode": "300079-500015",
      "SKUDescription": "INSOFORM 7 - 15 Kg",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "415",
      "ParentWhDesc": "DKCI Dadra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 30000,
      "Stock": 18000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 18000,
      "TOBlack_ReqQty": 18000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 18000,
      "RationedCasePacks": 18000,
      "TOBlack_AllocQty": 18000,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "18000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 6,
      "SKUCode": "300079-500015",
      "SKUDescription": "INSOFORM 7 - 15 Kg",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "P102",
      "ParentWhDesc": "DKCI Dadra Plant",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 30000,
      "Stock": 18000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 12000,
      "TOBlack_ReqQty": 6000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 6000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "18000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 7,
      "SKUCode": "300079-700300",
      "SKUDescription": "INSOFORM 7 - 300 KG",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "415",
      "ParentWhDesc": "DKCI Dadra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 30000,
      "Stock": 6000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 12000,
      "TOBlack_ReqQty": 12000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 6000,
      "RationedCasePacks": 6000,
      "TOBlack_AllocQty": 6000,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "6000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 8,
      "SKUCode": "300079-700300",
      "SKUDescription": "INSOFORM 7 - 300 KG",
      "WhCode": "415",
      "WHDescription": "DKCI Dadra",
      "ParentWhCode": "P102",
      "ParentWhDesc": "DKCI Dadra Plant",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 30000,
      "Stock": 6000,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 24000,
      "TOBlack_ReqQty": 18000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 6000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "6000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "NON HAZ",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 9,
      "SKUCode": "300129-100200",
      "SKUDescription": "TYZOR 726 200KG/440.529LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 21600,
      "Stock": 20600,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 21600,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 21600,
      "RationedQty": 20000,
      "RationedCasePacks": 20000,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 20000,
      "DispatchColor": "Blue",
      "AdvAllocDone": 9600,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "20600.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 10,
      "SKUCode": "300129-100200",
      "SKUDescription": "TYZOR 726 200KG/440.529LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "P1801",
      "ParentWhDesc": "DKCM Mundra Plant",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 21600,
      "Stock": 20600,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 15934,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 6334,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 9600,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Yellow",
      "AdvAllocDone": 9600,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "20600.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 11,
      "SKUCode": "300130-100180",
      "SKUDescription": "TYZOR 9000 180KG/396.476LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 7200,
      "Stock": 7380,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 7200,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 7200,
      "RationedQty": 7200,
      "RationedCasePacks": 7200,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 7200,
      "DispatchColor": "Blue",
      "AdvAllocDone": 3600,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "7380.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 12,
      "SKUCode": "300130-100180",
      "SKUDescription": "TYZOR 9000 180KG/396.476LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "P1801",
      "ParentWhDesc": "DKCM Mundra Plant",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 7200,
      "Stock": 7380,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 3600,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 3600,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Blue",
      "AdvAllocDone": 3600,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "7380.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 13,
      "SKUCode": "300130-100180",
      "SKUDescription": "TYZOR 9000 180KG/396.476LB DRM",
      "WhCode": "226",
      "WHDescription": "Sardo & Sons - WhiteClay, DE.",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 12240,
      "VirtualNorm": 12240,
      "Stock": 7920,
      "GIT": 2160,
      "LeftoverParentStock": 180,
      "Requirement": 2160,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 2160,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Green",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "2160.000",
      "SKULocAttr2": "7920.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "rmwillberesettoOriginalnormvalue(4860)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 14,
      "SKUCode": "300131-100025",
      "SKUDescription": "TYZOR AA 25KG SM DRM",
      "WhCode": "226",
      "WHDescription": "Sardo & Sons - WhiteClay, DE.",
      "ParentWhCode": "226",
      "ParentWhDesc": "Sardo & Sons - WhiteClay, DE.",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 25,
      "Stock": 25,
      "GIT": 0,
      "LeftoverParentStock": 75,
      "Requirement": 25,
      "TOBlack_ReqQty": 25,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 25,
      "RationedCasePacks": 25,
      "TOBlack_AllocQty": 25,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "25.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 15,
      "SKUCode": "300132-100025",
      "SKUDescription": "TYZOR AA-105 25KG SM DRUM",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 900,
      "VirtualNorm": 900,
      "Stock": 700,
      "GIT": 0,
      "LeftoverParentStock": 25,
      "Requirement": 200,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 200,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Green",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "700.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "ormwillberesettoOriginalnormvalue(600)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 16,
      "SKUCode": "300133-100190",
      "SKUDescription": "TYZOR AA-65 190KG/418.878LB DRM",
      "WhCode": "237",
      "WHDescription": "Seatex - Rosenberg, TX",
      "ParentWhCode": "237",
      "ParentWhDesc": "Seatex - Rosenberg, TX",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 1520,
      "Stock": 4100,
      "GIT": 4940,
      "LeftoverParentStock": 0,
      "Requirement": 1520,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 1520,
      "RationedQty": 1520,
      "RationedCasePacks": 1520,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 1520,
      "DispatchColor": "Blue",
      "AdvAllocDone": 1520,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "4560.000",
      "SKULocAttr2": "4100.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 17,
      "SKUCode": "300134-100025",
      "SKUDescription": "TYZOR AA-75 25KG SM DRM",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "241",
      "ParentWhDesc": "Mexico Natie - BlueStar Antwerp",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 50,
      "Stock": 475,
      "GIT": 200,
      "LeftoverParentStock": 1125,
      "Requirement": 50,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 50,
      "RationedQty": 50,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 50,
      "DispatchColor": "Blue",
      "AdvAllocDone": 25,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "475.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "ormwillberesettoOriginalnormvalue(250)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 18,
      "SKUCode": "300134-100025",
      "SKUDescription": "TYZOR AA-75 25KG SM DRM",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 675,
      "VirtualNorm": 675,
      "Stock": 475,
      "GIT": 200,
      "LeftoverParentStock": 1125,
      "Requirement": 50,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 50,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Green",
      "AdvAllocDone": 25,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "475.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "ormwillberesettoOriginalnormvalue(250)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 19,
      "SKUCode": "300134-100025",
      "SKUDescription": "TYZOR AA-75 25KG SM DRM",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 50,
      "Stock": 475,
      "GIT": 200,
      "LeftoverParentStock": 1125,
      "Requirement": 25,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 25,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Blue",
      "AdvAllocDone": 25,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "475.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "ormwillberesettoOriginalnormvalue(250)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 20,
      "SKUCode": "300134-100200",
      "SKUDescription": "TYZOR AA-75 200KG/440.924LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 3800,
      "Stock": 19800,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 3800,
      "TOBlack_ReqQty": 3800,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 3800,
      "RationedCasePacks": 3800,
      "TOBlack_AllocQty": 3800,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "19800.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 21,
      "SKUCode": "300137-100200",
      "SKUDescription": "TYZOR BTP 200KG/440.924LB STL DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 16800,
      "Stock": 17400,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 16800,
      "TOBlack_ReqQty": 16000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 800,
      "RationedQty": 16800,
      "RationedCasePacks": 16800,
      "TOBlack_AllocQty": 16000,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 800,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "17400.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 22,
      "SKUCode": "300137-100200",
      "SKUDescription": "TYZOR BTP 200KG/440.924LB STL DRM",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 45000,
      "VirtualNorm": 45000,
      "Stock": 13000,
      "GIT": 0,
      "LeftoverParentStock": 600,
      "Requirement": 32000,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 2000,
      "TOY_ReqQty": 15000,
      "TOGreen_ReqQty": 15000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Red",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "13000.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 23,
      "SKUCode": "300137-100200",
      "SKUDescription": "TYZOR BTP 200KG/440.924LB STL DRM",
      "WhCode": "226",
      "WHDescription": "Sardo & Sons - WhiteClay, DE.",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 12000,
      "VirtualNorm": 12000,
      "Stock": 3600,
      "GIT": 0,
      "LeftoverParentStock": 600,
      "Requirement": 8400,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 400,
      "TOY_ReqQty": 4000,
      "TOGreen_ReqQty": 4000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Red",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "3600.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 24,
      "SKUCode": "300142-100200",
      "SKUDescription": "TYZOR ET 200KG/440.924LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 16000,
      "Stock": 17800,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 16000,
      "TOBlack_ReqQty": 16000,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 16000,
      "RationedCasePacks": 16000,
      "TOBlack_AllocQty": 16000,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Black",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "22000.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 25,
      "SKUCode": "300142-100200",
      "SKUDescription": "TYZOR ET 200KG/440.924LB DRM",
      "WhCode": "226",
      "WHDescription": "Sardo & Sons - WhiteClay, DE.",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 2400,
      "Stock": 3400,
      "GIT": 5000,
      "LeftoverParentStock": 200,
      "Requirement": 2400,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 2400,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 0,
      "RationedQty": 1600,
      "RationedCasePacks": 2,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 1600,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Red",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "800.000",
      "SKULocAttr2": "3400.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 26,
      "SKUCode": "300142-271000",
      "SKUDescription": "Tyzor ET 1000KG UV BLOCK IBC",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "241",
      "ParentWhDesc": "Mexico Natie - BlueStar Antwerp",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 16000,
      "Stock": 14000,
      "GIT": 21000,
      "LeftoverParentStock": 1000,
      "Requirement": 16000,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 16000,
      "RationedQty": 14000,
      "RationedCasePacks": 14,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 14000,
      "DispatchColor": "Blue",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "12000.000",
      "SKULocAttr2": "14000.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "mwillberesettoOriginalnormvalue(12000)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 27,
      "SKUCode": "300142-271000",
      "SKUDescription": "Tyzor ET 1000KG UV BLOCK IBC",
      "WhCode": "241",
      "WHDescription": "Mexico Natie - BlueStar Antwerp",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 26000,
      "VirtualNorm": 26000,
      "Stock": 14000,
      "GIT": 21000,
      "LeftoverParentStock": 1000,
      "Requirement": 7000,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 7000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Green",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "12000.000",
      "SKULocAttr2": "14000.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "mwillberesettoOriginalnormvalue(12000)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "Europe",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 28,
      "SKUCode": "300142-271000",
      "SKUDescription": "Tyzor ET 1000KG UV BLOCK IBC",
      "WhCode": "226",
      "WHDescription": "Sardo & Sons - WhiteClay, DE.",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Norm",
      "Norm": 50000,
      "VirtualNorm": 50000,
      "Stock": 31000,
      "GIT": 9000,
      "LeftoverParentStock": 1000,
      "Requirement": 10000,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 10000,
      "TOBlue_ReqQty": 0,
      "RationedQty": 0,
      "RationedCasePacks": 0,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 0,
      "DispatchColor": "Green",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "9000.000",
      "SKULocAttr2": "31000.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "mwillberesettoOriginalnormvalue(24000)on2024.11.24",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 29,
      "SKUCode": "300143-100025",
      "SKUDescription": "TYZOR GBA 25KG SM DRUM",
      "WhCode": "226",
      "WHDescription": "Sardo & Sons - WhiteClay, DE.",
      "ParentWhCode": "226",
      "ParentWhDesc": "Sardo & Sons - WhiteClay, DE.",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 25,
      "Stock": 75,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 25,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 25,
      "RationedQty": 25,
      "RationedCasePacks": 1,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 25,
      "DispatchColor": "Blue",
      "AdvAllocDone": 25,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "75.000",
      "SKULocAttr3": "",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "WH",
      "LocAttr2": "NAM",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    },
    {
      "RN": 30,
      "SKUCode": "300143-100200",
      "SKUDescription": "TYZOR GBA 200KG/440.529LB DRM",
      "WhCode": "334",
      "WHDescription": "DKCM Mundra",
      "ParentWhCode": "334",
      "ParentWhDesc": "DKCM Mundra",
      "AllocationFor": "Order",
      "Norm": 0,
      "VirtualNorm": 1600,
      "Stock": 1600,
      "GIT": 0,
      "LeftoverParentStock": 0,
      "Requirement": 1600,
      "TOBlack_ReqQty": 0,
      "TOR_ReqQty": 0,
      "TOY_ReqQty": 0,
      "TOGreen_ReqQty": 0,
      "TOBlue_ReqQty": 1600,
      "RationedQty": 1600,
      "RationedCasePacks": 1600,
      "TOBlack_AllocQty": 0,
      "TOR_AllocQty": 0,
      "TOY_AllocQty": 0,
      "TOGreen_AllocQty": 0,
      "TOBlue_AllocQty": 1600,
      "DispatchColor": "Blue",
      "AdvAllocDone": 0,
      "sl1": "",
      "sl2": "",
      "sl3": "",
      "sl4": "",
      "sl5": "",
      "ll1": "",
      "ll2": "",
      "ll3": "",
      "ll4": "",
      "ll5": "",
      "SKULocAttr1": "-",
      "SKULocAttr2": "4200.000",
      "SKULocAttr3": "10",
      "SKULocAttr4": "",
      "SKULocAttr5": "3",
      "SKULocAttr6": "-",
      "SKULocAttr7": "",
      "SKULocAttr8": "",
      "SKULocAttr9": "",
      "SKULocAttr10": "",
      "SKULocAttr11": "",
      "SKULocAttr12": "",
      "SKULocAttr13": "",
      "SKULocAttr14": "",
      "SKULocAttr15": "",
      "SKUAttr1": "",
      "SKUAttr2": "",
      "SKUAttr3": "",
      "SKUAttr4": "",
      "SKUAttr5": "",
      "SKUAttr6": "",
      "SKUAttr7": "",
      "SKUAttr8": "",
      "SKUAttr9": "",
      "SKUAttr10": "",
      "SKUAttr11": "",
      "SKUAttr12": "",
      "SKUAttr13": "",
      "SKUAttr14": "",
      "SKUAttr15": "",
      "LocAttr1": "CWH",
      "LocAttr2": "",
      "LocAttr3": "",
      "LocAttr4": "",
      "LocAttr5": "",
      "LocAttr6": "",
      "LocAttr7": "",
      "LocAttr8": "",
      "LocAttr9": "",
      "LocAttr10": "",
      "LocAttr11": "",
      "LocAttr12": "",
      "LocAttr13": "",
      "LocAttr14": "",
      "LocAttr15": ""
    }
  ]